function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { parse, filter } from '@sky-uk-ott/core-video-sdk-js-external-txml/dist/txml';
var noop = function(val) {
    return val;
};
var convertToNumber = function(val) {
    return +val;
};
var convertToBool = function(val) {
    return val === 'Y';
};
var createNull = function() {
    return null;
};
var createFalse = function() {
    return false;
};
var createEmptyArray = function() {
    return [];
};
var defaultEventDataKeyMap = {
    'p.pr': {
        name: 'parentalRating',
        typeConverter: convertToNumber,
        createDefault: createNull
    },
    'p.ev': {
        name: 'eventRating',
        typeConverter: convertToNumber,
        createDefault: createNull
    },
    'p.dur': {
        name: 'eventDuration',
        typeConverter: convertToNumber,
        createDefault: createNull
    },
    'p.id': {
        name: 'presentEventID',
        typeConverter: noop,
        createDefault: createNull
    },
    'p.st': {
        name: 'startTime',
        typeConverter: convertToNumber,
        createDefault: createNull
    },
    'p.rst': {
        name: 'isRestartable',
        typeConverter: convertToBool,
        createDefault: createFalse
    },
    'f.id': {
        name: 'followingEventID',
        typeConverter: noop,
        createDefault: createNull
    },
    s: {
        name: 'subtitleTracks',
        typeConverter: noop,
        createDefault: createEmptyArray
    },
    a: {
        name: 'audioTracks',
        typeConverter: noop,
        createDefault: createEmptyArray
    }
};
var xmlStartString = '<?xml ';
function splitOnXmlStart(xml) {
    return xml.substring(xml.indexOf(xmlStartString)).trim();
}
export function parseID3Data(id3data) {
    var parsedData = parse(id3data);
    if (!parsedData) return null;
    var paragraphNodes = filter(parsedData, function(node) {
        return node.tagName === 'p';
    });
    var latestNode = paragraphNodes === null || paragraphNodes === void 0 ? void 0 : paragraphNodes.pop();
    if (latestNode) {
        var _filter;
        var textContentNode = (_filter = filter([
            latestNode
        ], function(node) {
            return typeof node.children[0] === 'string';
        })) === null || _filter === void 0 ? void 0 : _filter[0];
        return textContentNode ? textContentNode.children[0] : '';
    }
    return null;
}
var splitEventDataProps = function(delimiter) {
    return function(part) {
        var _part_split = _sliced_to_array(part.split(delimiter), 2), name = _part_split[0], value = _part_split[1];
        return {
            name: name,
            value: value
        };
    };
};
var reduceEventData = function(eventDataKeyMap) {
    return function(result, param) {
        var name = param.name, value = param.value;
        if (value === '' || value === undefined) {
            return result;
        }
        var subAudioMatch = name.match(/^p\.([sa])(\d+)\.id$/);
        if (subAudioMatch) {
            // subAudioMatch[1] will be either a for audio or s subtitles
            var subAudioOb = eventDataKeyMap[subAudioMatch[1]];
            // This pushes audio or subtitle tracks into the relevant array
            result[subAudioOb.name].push({
                lang: subAudioOb.typeConverter(value),
                position: +subAudioMatch[2]
            });
        } else {
            var eventDataMapping = eventDataKeyMap[name];
            if (eventDataMapping) {
                result[eventDataMapping.name] = eventDataMapping.typeConverter(value);
            }
        }
        return result;
    };
};
export var parseEventDataString = function() {
    var eventData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', eventDataKeyMap = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultEventDataKeyMap;
    var initialisedResultObject = Object.keys(eventDataKeyMap).reduce(function(prev, nextKey) {
        prev[eventDataKeyMap[nextKey].name] = eventDataKeyMap[nextKey].createDefault();
        return prev;
    }, {});
    var result = eventData.split(',').map(function(s) {
        return s.trim();
    }).map(splitEventDataProps('=')).reduce(reduceEventData(eventDataKeyMap), initialisedResultObject);
    var langSort = function(a, b) {
        return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
    };
    result.subtitleTracks.sort(langSort);
    result.audioTracks.sort(langSort);
    return result;
};
export function createBoundaryEventFromID3(id3MetaData) {
    var isTtmlWrapped = id3MetaData.includes(xmlStartString);
    var currentEventString = isTtmlWrapped ? parseID3Data(splitOnXmlStart(id3MetaData)) : id3MetaData;
    if (currentEventString) {
        var currentEvent = parseEventDataString(currentEventString);
        return typeof currentEvent.presentEventID === 'string' && currentEvent.presentEventID.length > 0 ? {
            isEventBoundary: null,
            isFirstEvent: null,
            currentEventData: currentEvent
        } : null;
    } else {
        return null;
    }
}

//# sourceMappingURL=event-boundary.js.map